import React, { Component } from 'react'

import classes from './FileInput.scss'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Button from '../../../UI/Button/Button'
import { AttachFile } from '@material-ui/icons'

class FileInput extends Component {
  constructor(props) {
    super(props)

    this.fileInputRef = React.createRef()
  }

  browseFile = () => {
    this.fileInputRef.current.click()
  }

  render() {
    const { selected, changed, configs, variant, disabled } = this.props

    const fileName = selected ? selected.name : ''

    let input = (
      <input
        type={'text'}
        onClick={this.browseFile}
        className={classes.FileName}
        value={fileName}
        readOnly
        disabled={disabled}
        {...configs}
      />
    )

    if (variant === 'button') {
      input = (
        <Button color={'default'} clicked={this.browseFile} disabled={disabled}>
          <AttachFile />
        </Button>
      )
    }

    return (
      <Aux>
        {input}
        <div className={classes.FileInput}>
          <input type={'file'} ref={this.fileInputRef} filename={fileName} onChange={changed} />
        </div>
      </Aux>
    )
  }
}

export default FileInput
